import OrdemPagamentoModel from "@/models/financeiro/gatewayPagamento/ordemPagamentoModel";

import nfetch from "../utils/events/nfetch";

import { IService } from "./base/iService";

export default class OrdemPagamentoService extends IService<OrdemPagamentoModel> {
    constructor() {
        super("OrdemPagamento");
    }

    public getOrdemPagamentoAtivoByContaReceberId(contaReceberId: number): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/GetOrdemPagamentoAtivoByContaReceberId?contaReceberId=${contaReceberId}`,
            {
                credentials: "same-origin",
            },
        );
    }

    public criarOrdemPagamentoByContaReceberId(
        contaReceberId: number,
        valorTotal: number,
        dataVencimento: string,
        gateway: number,
    ): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/CriarOrdemPagamentoByContaReceberId?contaReceberId=${contaReceberId}&valorTotal=${valorTotal}&dataVencimento=${dataVencimento}&gateway=${gateway}`,
            {
                credentials: "same-origin",
                method: "post",
            },
        );
    }
}
